import styled from 'styled-components';
import Icon from '../../assets/images/risk-icon.svg';

interface RiskIconProps {
  /** Icon height in `px`. Defaults to `45px`. */
  height?: string;

  /** Icon width in `px`. Defaults to `45px`. */
  width?: string;

  /** Icon fill colour. Defaults to `#57779A` */
  fill?: string;
}

const RiskIcon = styled.span<RiskIconProps>`
  ${({ fill = '#57779A', height = '45px', width = '45px' }) => `
    background-color: ${fill};
    display: inline-block;
    height: ${height};
    mask-image: url("${Icon}");
    mask-position: center center;
    mask-repeat: no-repeat;
    mask-size: 100%;
    position: relative;
    width: ${width};
  `}
`;

export default RiskIcon;
